import script from "./applications.vue?vue&type=script&lang=ts&setup=true"
export * from "./applications.vue?vue&type=script&lang=ts&setup=true"

import "./applications.vue?vue&type=style&index=0&id=78022f88&lang=scss&scoped=true"
import "./applications.vue?vue&type=style&index=1&id=78022f88&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78022f88"]])

export default __exports__